<template>

    <div class="container">

        <header class="stepper">

            <div class="stepper__wrap">

                <router-link tag="section" class="item--sm" :to="{name:'option.index'}">

                    <i class="fas fa-times dark-grey"></i>

                </router-link>

                <template>

                    <router-link tag="section" class="item--md" active-class="item--active" :to="{name:'option.create.option'}" v-if="isCreating">

                        <div class="icon">

                            <i class="fas fa-utensils"></i>

                        </div>

                        <div class="content">

                            <h1>Ret</h1>

<!--                            <p>Påbegyndt</p>-->

                        </div>

                    </router-link>

                    <router-link tag="section" class="item--md" active-class="item--active" :to="{name:'option.edit.option', params:{option:this.$route.params.option}}" v-else>

                        <div class="icon">

                            <i class="fas fa-utensils"></i>

                        </div>

                        <div class="content">

                            <h1>Ret</h1>

<!--                            <p>Klar</p>-->

                        </div>

                    </router-link>

                </template>

                <template>
                    <router-link tag="section" class="item--md" active-class="item--active" :to="{name:'option.edit.packaging', params:{option:this.$route.params.option}}" v-if="!isCreating">

                        <div class="icon">

                            <i class="fas fa-tag"></i>

                        </div>

                        <div class="content">

                            <h1>Anretning & pakning</h1>

<!--                            <p>Påbegyndt</p>-->

                        </div>

                    </router-link>

                    <section class="item--md item--disabled" v-else>

                        <div class="icon">

                            <i class="fas fa-tag"></i>

                        </div>

                        <div class="content">

                            <h1>Anretning & pakning</h1>

<!--                            <p>Påbegyndt</p>-->

                        </div>

                    </section>
                </template>

<!--                <template>
                    <router-link tag="section" active-class="item&#45;&#45;active"  class="item&#45;&#45;md" :to="{name:'product.edit.approve', params:{course:this.$route.params.product}}" v-if="!isCreating && selectionsValidated">

                        <div class="icon">

                            <i class="fas fa-thumbs-up"></i>

                        </div>

                        <div class="content">

                            <h1>Godkend</h1>

                            <p>Påbegyndt</p>

                        </div>

                    </router-link>
                    <section class="item&#45;&#45;md item&#45;&#45;disabled" v-else>

                        <div class="icon">

                            <i class="fas fa-thumbs-up"></i>

                        </div>

                        <div class="content">

                            <h1>Godkend</h1>

                            <p>Påbegyndt</p>

                        </div>

                    </section>
                </template>-->


            </div>

        </header>

        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>


    </div>

</template>

<script>
import {mapGetters} from 'vuex';
export default {
    name: "stepper",
    computed:{
        isCreating(){
            return this.$route.params.option == null;
        },
    },
    methods:{

        backToIndex(){
            this.$router.push({
                name:'option.index',
            })
        },
    },
}
</script>
